import React from 'react';
import { useFormContext } from 'react-hook-form';

import CheckoutStripeElements from 'apps/commerce/common/checkout/components/CheckoutStripeElements';
import EmbeddedCheckoutForm from './components/EmbeddedCheckoutForm';

interface Props {
  offerToken: string;
}

// eslint-disable-next-line no-unused-vars
import i18next from '../translations/i18n';

const EmbeddedCheckout = ({ offerToken }: Props) => {
  const { getValues } = useFormContext();
  const {
    stripe,
    attemptReloadWithCardsOnly,
    currency,
    paymentMethods,
    additionalPaymentMethods,
    vendorAccountId,
  } = getValues();
  const amountPriceInCents = getValues('price').amount * 100;

  return (
    <CheckoutStripeElements
      attemptReloadWithCardsOnly={attemptReloadWithCardsOnly}
      stripe={stripe}
      amountPriceInCents={amountPriceInCents}
      currency={currency}
      paymentMethods={paymentMethods}
      additionalPaymentMethods={additionalPaymentMethods}
      vendorAccountId={vendorAccountId}
    >
      <EmbeddedCheckoutForm offerToken={offerToken} />
    </CheckoutStripeElements>
  );
};

export default EmbeddedCheckout;
